module.exports = __webpack_public_path__ + "static/media/logo.f1c50b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 44
// module chunks = 0